import React, {Component} from 'react'
import MarkItemPrinted from './MarkItemPrinted'
import '../styles/index.scss'

class MarkItemPrintedContainer extends Component {
    render() {
        return (
            <div className='MarkItemPrintedContainer'>
                <MarkItemPrinted/>
            </div>
        )
    }
}

export default MarkItemPrintedContainer
